<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-dialog v-model="isDialog"  style="z-index:100000">
    <v-card flat style="overflow: auto">
      <v-card-title flat class='blue white--text title py-2'>{{ 'DIALOG_TITLE_OVERALL_SEARCH' | translate}}
        <v-spacer></v-spacer>
        <v-btn small @click="close" icon flat dark>
          <v-icon>clear</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text flat>
        <v-content v-if="!showCompanies && !showBanks && !showInsurances">
          {{ 'RESULT_EMPTY_OVERALL_SEARCH' | translate}}
        </v-content>
        <div v-if="isLoading" style="position: absolute;z-index:10; background-color:white;left:0px;top:48px;bottom:0px;right:0px;">
          <v-container>
            <div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
          </v-container>
        </div>

          <v-expansion-panel v-model="panel" expand class="smallerexpansion pa-0" flat>
            <v-expansion-panel-content
              :key="0"
              v-if="showCompanies"
            >
              <template v-slot:header>
                <span class="underline"></span>
                <div>{{ 'COMPANIES_TITLE' | translate}}</div>
              </template>
              <v-card class="pa-0" flat>
                <v-card-text class="pa-0">
                  <StrukturBilanzTable
                    :isClickable='true'
                    clickEventName="openOSItem"
                    :sortDisabled="true"
                    :maxHeight="-1"
                    :fixedHeight="fixedHeight1"
                    :widthSub="84"
                    :heightSub="tableHeightSub"
                    ref="tabCompany"
                    tableName="companies"
                    edoClassName="sb">
                  </StrukturBilanzTable>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
            <v-expansion-panel-content
              :key="2"
              v-if="showBanks"
            >
              <template v-slot:header>
                <span class="underline"></span>
                <div>{{ 'BANKS_TITLE' | translate}}</div>
              </template>
              <v-card class="pa-0" flat>
                <v-card-text class="pa-0">
                  <StrukturBilanzTable
                    :isClickable='true'
                    clickEventName="openOSItem"
                    :sortDisabled="true"
                    :fixedHeight="fixedHeight2"
                    :maxHeight="-1"
                    :widthSub="84"
                    :heightSub="tableHeightSub"
                    ref="tabBanks"
                    tableName="banks"
                    edoClassName="sb">
                  </StrukturBilanzTable>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
            <v-expansion-panel-content
              :key="1"
              v-if="showInsurances"
            >
              <template v-slot:header>
                <span class="underline"></span>
                <div>{{ 'INSURANCES_TITLE' | translate}}</div>
              </template>
              <v-card class="pa-0" flat>
                <v-card-text class="pa-0">
                  <StrukturBilanzTable
                    :isClickable='true'
                    clickEventName="openOSItem"
                    :sortDisabled="true"
                    :fixedHeight="fixedHeight3"
                    :maxHeight="-1"
                    :widthSub="84"
                    :heightSub="tableHeightSub"
                    ref="tabInsurances"
                    tableName="insurances"
                    edoClassName="sb">
                  </StrukturBilanzTable>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
      </v-card-text>
     <!-- <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close">{{ 'DIALOG_CLOSE' | translate}}</v-btn>
      </v-card-actions>-->
    </v-card>
  </v-dialog>
</template>
<script>
  import Vue from 'vue'
  import StrukturBilanzTable from './../akte/StrukturBilanzTable'
  import MockTable from './../../tables/MockTable.vue'
  export default {
    name: 'DialogOverallSearch',
    components: {MockTable, StrukturBilanzTable},
    methods: {
      open: function () {
      },
      close: function () {
        this.isDialog = false
        Vue.prototype.$api.hideIdle()
      },
      onGetBanksHitList: function (data) {
        var cmp = this
        this.$nextTick(function () {
          if (cmp.hitListIndex === 0) {
            cmp.hitListIndex ++
            Vue.prototype.$api.getGSHitListColumnsForUser('companies', cmp.onGetBanksHitList)
          } else if (this.hitListIndex === 1) {
            cmp.columnCompanies = Vue.prototype.$api.getColumnsString(data.array)
            cmp.hitListIndex ++
            Vue.prototype.$api.getGSHitListColumnsForUser('banks', cmp.onGetBanksHitList)
          } else if (this.hitListIndex === 2) {
            cmp.columnBanks = Vue.prototype.$api.getColumnsString(data.array)
            Vue.prototype.$api.requestHyperSearch({
              columnsCompanies: cmp.columnCompanies,
              columnsBanks: cmp.columnBanks,
              keyword: cmp.keyWord
            }, cmp.onGetHyperData)
          }
        })
      },
      show: function (searchText) {
        this.isLoading = true
        this.showInsurances = true
        this.showBanks = true
        this.showCompanies = true
        let data = {}
        // if (this.$refs['tabCompany'] && this.$refs['tabCompany'].open) this.$refs['tabCompany'].open(data)
        // if (this.$refs['tabBanks'] && this.$refs['tabBanks'].open) this.$refs['tabBanks'].open(data)
        // if (this.$refs['tabInsurances'] && this.$refs['tabInsurances'].open) this.$refs['tabInsurances'].open(data)
        Vue.prototype.$api.debug('searchText', searchText)
        Vue.prototype.$api.showIdle()
        var cmp = this
        this.keyWord = searchText
        this.isDialog = true
        this.panel = [true, true, true]
        Vue.prototype.$api.showIdle()
        this.hitListIndex = 0
        this.onGetBanksHitList(null)
        /*
        Vue.prototype.$api.requestHyperSearch({
          columnsCompanies: '',
          columnsBanks: '',
          keyword: cmp.keyWord
        }, this.onGetHyperData)
         */
      },
      onGetHyperData: function (data) {
        Vue.prototype.$api.debug('onGetHyperData', data)
        this.tableData = data
        this.isLoading = false
        Vue.prototype.$api.hideIdle()
        this.showInsurances = false
        this.showBanks = false
        this.showCompanies= false
        if (data.tables.banks && data.tables.banks.rows.length > 0 ) {
          this.showBanks = true
          this.fixedHeight1 = (data.tables.banks.rows.length * 30) + 100
        }
        if (data.tables.companies && data.tables.companies.rows.length > 0 ) {
          this.showCompanies = true
          this.fixedHeight2 = data.tables.companies.rows.length * 30 + 100
        }
        if (data.tables.insurances && data.tables.insurances.rows.length > 0 ) {
          this.showInsurances = true
          this.fixedHeight3 = data.tables.insurances.rows.length * 30 + 100
        }
        this.fixedHeight1 = -1
        this.fixedHeight2 = -1
        this.fixedHeight3 = -1
        // console.log('this.showBanks', this.showBanks, this.fixedHeight1)
        // console.log('this.showCompanies', this.showCompanies, this.fixedHeight2)
        // console.log('this.showInsurances', this.showInsurances, this.fixedHeight3)
        if (this.$refs['tabCompany'] && this.$refs['tabCompany'].open) this.$refs['tabCompany'].open(data)
        if (this.$refs['tabBanks'] && this.$refs['tabBanks'].open) this.$refs['tabBanks'].open(data)
        if (this.$refs['tabInsurances'] && this.$refs['tabInsurances'].open) this.$refs['tabInsurances'].open(data)
      }
    },
    data () {
      return {
        columnCompanies: null,
        columnBanks: null,
        selectedModule: [],
        fixedHeight1: 300,
        fixedHeight2: 300,
        fixedHeight3: 300,
        data: null,
        list: [],
        panel: [true, true, true],
        showInsurances: true,
        showBanks: true,
        showCompanies: true,
        isLoading: true,
        tableHeightSub: 100,
        tableData: null,
        lableKeyWord: Vue.i18n.translate('LABEL_KEYWORD_OVERALLSEARCH'),
        keyWord: '',
        isDialog: false
      }
    },
    mounted () {
      Vue.prototype.$api.checkCredentials(this)
      var list = Vue.prototype.$api.getModuleList()
      this.list = []
      this.selectedModule = []
      for (var index in list) {
        var item = list[index]
        var obj = {
          name: index,
          meta: item
        }
        this.list.push(obj)
        this.selectedModule.push(obj)
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/module/dialogs/DialogOverallSearch.vue